export default __webpack_public_path__ + "static/media/c002-PPII-13.b6f42075.svg";